export const siteInfo = {
  name: '爆料专区',
  tagline: '第一时间，吃最新鲜的瓜',
  description: '爆料专区汇集全网最新爆料、今日爆料及热门爆料合集，每日更新独家爆料视频与内幕猛料，满足你对新鲜瓜料的好奇心，第一时间获取劲爆资讯。',
  keywords: '爆料专区, 最新爆料, 今日爆料, 热门爆料, 独家爆料, 爆料合集, 爆料视频, 内幕猛料, 吃瓜爆料, 实时爆料',
  url: 'https://baoliao.example.com',
  email: 'contact@baoliao.example.com',
  phone: '400-888-6666',
  address: '北京市朝阳区光华路甲1号',
  founded: '2018',
  teamSize: '200+',
  dailyVisitors: '500万+',
  totalArticles: '10万+',
  socialLinks: {
    weibo: 'https://weibo.com/baoliao',
    wechat: 'https://mp.weixin.qq.com/s/baoliao',
    douyin: 'https://www.douyin.com/user/baoliao',
  },
};